import React from 'react';
import './CustomConfirmModalStyle.css';
import CustomModal from '../CustomModal/CustomModal';
import ActionButton from '../CustomButtons/ActionButton/ActionButton';

function CustomConfirmModal({ isButtonDisabled, open_modal, close_modal, confirm_function, custom_text }) {
    return (
        <CustomModal
            open={open_modal}
            handleClose={close_modal}
            title="Are You Sure?"
            body={
                <div className="custom_confirm_modal_body">
                    <p className="custom_confirm_modal_text">{custom_text}</p>
                    <div className="custom_confirm_modal_action_container">

                        <ActionButton
                            label="No"
                            btnType="outlined"
                            onClick={() => close_modal(false)}
                            fullWidth

                        />
                        <ActionButton
                            onClick={() => confirm_function()}
                            label="Yes"
                            btnType="primary"
                            fullWidth
                            btnDisable={isButtonDisabled}
                        />
                    </div>
                </div>
            }
        />
    );
}

export default CustomConfirmModal;
